/**
 * Frontend icon collection
 * To have these icons selectable in processwire admin, add them to fontawesome/metadata.js and run `npm run icons`
 */

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faTools } from "@fortawesome/free-solid-svg-icons/faTools";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faTasks } from "@fortawesome/free-solid-svg-icons/faTasks";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkerAlt";
import { faMapMarkedAlt } from "@fortawesome/free-solid-svg-icons/faMapMarkedAlt";
import { faCalendar } from "@fortawesome/free-regular-svg-icons/faCalendar";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons/faExternalLinkAlt";
import { faTicketAlt } from "@fortawesome/free-solid-svg-icons/faTicketAlt";
import { faLink } from "@fortawesome/free-solid-svg-icons/faLink";
import { faRecordVinyl } from "@fortawesome/free-solid-svg-icons/faRecordVinyl";
import { faMusic } from "@fortawesome/free-solid-svg-icons/faMusic";
import { faPlay } from "@fortawesome/free-solid-svg-icons/faPlay"; 
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons/faFilePdf";

import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";


library.add(faTools, faCheck, faTimes, faFacebook, faInstagram, 
    faMapMarkedAlt, faMapMarkerAlt, faLink, faCalendar, faExternalLinkAlt, faTicketAlt, faTasks,
    faRecordVinyl, faMusic, faPlay, faDownload, faFilePdf);

export default class FaModule {

    static name = 'fa'

    constructor(node) {
        dom.watch();
    }
}